/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetProvinceBaseRequest } from '../../models/get-province-base-request';
import { ProvinceModel } from '../../models/province-model';

export interface PostApiProvinceV1Getall$Json$Params {

/**
 * Optional Impersonation User header
 */
  'X-Impersonated-User'?: string;
      body?: GetProvinceBaseRequest
}

export function postApiProvinceV1Getall$Json(http: HttpClient, rootUrl: string, params?: PostApiProvinceV1Getall$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ProvinceModel>>> {
  const rb = new RequestBuilder(rootUrl, postApiProvinceV1Getall$Json.PATH, 'post');
  if (params) {
    rb.header('X-Impersonated-User', params['X-Impersonated-User'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ProvinceModel>>;
    })
  );
}

postApiProvinceV1Getall$Json.PATH = '/private/v1/provinces';
